import React, { ReactElement } from 'react'
import { TermLinkProps } from '..'
import { useTranslation } from 'next-i18next'
import { TermLink } from '../TermLink'
import { useIsCashApp, useIsCountry } from '../../state'
import { Features } from '../../model'
import { useFlag } from '@afterpaytouch/feature'
import { Country } from '@afterpay/types'

interface UseSignUpTermsResult {
  readonly [tagName: string]: ReactElement<TermLinkProps>
}

export const useTermsKey = (): string => {
  const isCashApp = useIsCashApp()
  const isUK = useIsCountry(Country.GB)
  const isUkCreditCheckEnabled = useFlag(Features.UK_CREDIT_CHECK_ENABLED)
  if (isUK && isUkCreditCheckEnabled) {
    return 'signUp:terms_creditCheck'
  }
  if (isCashApp) {
    return 'signUp:cash_terms'
  }
  return 'signUp:terms'
}

export const useSignUpTerms = (): UseSignUpTermsResult => {
  const { t } = useTranslation()

  return {
    cashapplink: <TermLink key='payment-options-cash-app' color='Orca' href={t('common:cashAppPrivacyPolicyUrl')} />,
    terms: <TermLink key='sign-up-terms-of-service' href={t('common:termsOfServiceUrl')} color={'Orca'} />,
    consent: <TermLink key='payment-options-consent' color='Orca' href={`${t('common:termsOfServiceUrl')}#e-sign`} />,
    privacy: <TermLink key='sign-up-privacy-policy' href={t('common:privacyPolicyUrl')} color={'Orca'} />,
    optOut: <TermLink key='sign-up-opt-out' href={t('common:marketingOptOutUrl')} />,
    creditcheck: <TermLink key='sign-up-credit-check' href={t('common:creditCheckUrl')} color={'Orca'} />,
  }
}
